import { useMutation } from '@tanstack/react-query';
import { useEffect, useState } from 'preact/hooks';
import { POST, POST_STOCK_AVAILABILITY } from '../../../../services';
import { collectItemCodes, toStockMap } from '../func/stockHelper';

/**
 * ดึงยอดคงเหลือของสินค้าที่อยู่ในตารางเคลม
 * ยอดที่ใช้ตัดสินคือ effectiveAvailableQty (netAvailableQty หักที่จองไว้แล้ว)
 * ยิงใหม่ทุกครั้งที่รายการในตารางเปลี่ยน และเรียก refetch เองได้หลังอนุมัติ
 */
export const useStockAvailability = (dataSource) => {
  const [stockMap, setStockMap] = useState({});
  const [meta, setMeta] = useState({ company: '', brand: '', staleMinutes: 0 });
  const [unavailable, setUnavailable] = useState(false);

  const { isPending, mutate } = useMutation({
    mutationFn: async (itemCodes) => {
      const response = await POST(POST_STOCK_AVAILABILITY(), { itemCodes });
      return response?.result?.item ?? response?.result;
    },
    onSuccess: (result) => {
      setUnavailable(false);
      setStockMap(toStockMap(result?.items));
      setMeta({
        company: result?.company ?? '',
        brand: result?.brand ?? '',
        staleMinutes: result?.staleMinutes ?? 0,
      });
    },
    onError: () => {
      // ต่อ warranty_publish_db ไม่ได้ ไม่ควรทำให้ตารางใช้ไม่ได้ทั้งหน้า
      // แค่ไม่แสดงยอดคงเหลือ ส่วนการอนุมัติยังทำได้ตามปกติ
      setUnavailable(true);
      setStockMap({});
    },
  });

  const onFetchStock = () => {
    const itemCodes = collectItemCodes(dataSource);
    if (itemCodes.length === 0) {
      setStockMap({});
      return;
    }
    mutate(itemCodes);
  };

  useEffect(() => {
    onFetchStock();
  }, [dataSource]);

  return { stockMap, meta, unavailable, loading: isPending, onFetchStock };
};
